import { GlobalAxios } from "../axios/axios-config";
import {
  IMarComAutomationTime,
  INewMarComAutomationTimes,
} from "../models/mar-com-automation-time";

const CAMPAIGN_ROUTE =
  process.env.REACT_APP_AUTOMATIONS + "/api/v1/MarComAutomationTime";

export const createMarComAutomationTime = (
  params: INewMarComAutomationTimes
) => {
  return GlobalAxios.post(CAMPAIGN_ROUTE, params);
};

export const getMarComAutomationTimeById = (id: string) => {
  return GlobalAxios.get<IMarComAutomationTime>(CAMPAIGN_ROUTE + "/" + id);
};

export const updateMarComAutomationTime = ({
  id,
  item,
}: {
  id: string;
  item: INewMarComAutomationTimes;
}) => {
  return GlobalAxios.put(CAMPAIGN_ROUTE + "/" + id, item);
};
